import React from 'react';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
import IconComment from './IconDashboard/IconComment';
var ListTeamsItemStatusComment = function (props) {
    if (!props.teamScore || !props.teamScore.statusComment) {
        return null;
    }
    return (React.createElement(Tooltip, { title: props.teamScore.statusComment, visible: props.isActive },
        React.createElement(IconComment, null)));
};
export default ListTeamsItemStatusComment;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeamsItemStatusComment.tsx
// module id = 994
// module chunks = 0